export function TermsOfUse() {
  return (
    <>
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          These Terms of Use ("Terms") govern your access to and use of the Pediatric Speech
          Solutions website (the "Site"). By accessing or using the Site, you agree to be bound by
          these Terms. If you do not agree to these Terms, please do not use the Site.
        </p>
      </section>

      <section>
        <h2>2. Not Medical Advice</h2>
        <p>
          The content on this Site, including text, graphics, and other materials, is provided for
          general informational purposes only and does not constitute professional medical,
          therapeutic, or diagnostic advice. It is not a substitute for an individualized
          evaluation or consultation with a licensed speech-language pathologist or other qualified
          healthcare provider.
        </p>
        <p>
          Nothing on this Site creates a therapist-client relationship. A therapist-client
          relationship is only established once you have engaged Pediatric Speech Solutions for
          services through the appropriate intake and consent process.
        </p>
      </section>

      <section>
        <h2>3. Use of the Site</h2>
        <p>You agree to use the Site only for lawful purposes and agree not to:</p>
        <ul>
          <li>Use the Site in any way that violates applicable local, state, or federal law;</li>
          <li>
            Attempt to gain unauthorized access to any portion of the Site, other accounts, or
            computer systems connected to the Site;
          </li>
          <li>
            Interfere with or disrupt the operation of the Site or servers/networks connected to
            it; or
          </li>
          <li>
            Use any automated system, including "robots" or "spiders," to access the Site in a
            manner that sends more request messages than a human could reasonably produce.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>
          All content on this Site, including text, graphics, logos, images, and the overall
          design and layout, is the property of Pediatric Speech Solutions or its licensors and is
          protected by applicable copyright, trademark, and other intellectual property laws. You
          may view and print content from this Site for personal, non-commercial use only. No other
          use, including reproduction, distribution, or modification, is permitted without our
          prior written consent.
        </p>
      </section>

      <section>
        <h2>5. Contact Forms &amp; Submissions</h2>
        <p>
          Any information you submit through our contact form is provided voluntarily. Please do
          not submit sensitive medical details through the contact form; general inquiries and
          scheduling requests are appropriate, and detailed clinical information should be shared
          through appropriate, secure channels once services have begun.
        </p>
      </section>

      <section>
        <h2>6. Third-Party Links</h2>
        <p>
          This Site may contain links to third-party websites, including social media platforms,
          that are not owned or controlled by Pediatric Speech Solutions. We are not responsible
          for the content, accuracy, or practices of any third-party site and provide these links
          for convenience only.
        </p>
      </section>

      <section>
        <h2>7. Disclaimer of Warranties</h2>
        <p>
          The Site is provided on an "as is" and "as available" basis without warranties of any
          kind, either express or implied, including but not limited to implied warranties of
          merchantability, fitness for a particular purpose, and non-infringement. We do not
          warrant that the Site will be uninterrupted, error-free, or free of viruses or other
          harmful components.
        </p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by law, Pediatric Speech Solutions shall not be liable
          for any indirect, incidental, special, consequential, or punitive damages arising out of
          or related to your use of, or inability to use, the Site, even if we have been advised of
          the possibility of such damages.
        </p>
      </section>

      <section>
        <h2>9. Governing Law</h2>
        <p>
          These Terms are governed by and construed in accordance with the laws of the State of
          Florida, without regard to its conflict of law principles. Any disputes arising under
          these Terms shall be subject to the exclusive jurisdiction of the state and federal
          courts located in Martin County, Florida.
        </p>
      </section>

      <section>
        <h2>10. Changes to These Terms</h2>
        <p>
          We may revise these Terms at any time by updating this page. By continuing to use the
          Site after changes are posted, you agree to be bound by the revised Terms.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          If you have questions about these Terms of Use, please contact us through the form on our
          website or via our social media pages linked in the footer of this Site.
        </p>
      </section>
    </>
  );
}
